import React, { useEffect } from 'react';
import { Dialog, Heading, Stack, Text, TextLink } from '@origin-digital/ods-core';
import { AddressNMISearch } from '../AddressMeterSearch/AddressNMISearch';
import { useAddressSearch } from '../AddressMeterSearch/useAddressSearch';
import { IOriginAddressMeter } from '../fetchers';

export interface DedicatedNmiSearchModalProps {
  isOpen: boolean;
  onClose: () => void;
  searchByNmi: {
    endpoint: string;
    onConfirm: (address: IOriginAddressMeter) => void;
  };
  hasGasOnly?: boolean;
  autoOpen?: (value: boolean) => void;
}

export const DedicatedNmiSearchModal = ({
  isOpen,
  onClose,
  searchByNmi,
  hasGasOnly: _hasGasOnly,
  autoOpen,
}: DedicatedNmiSearchModalProps) => {
  const { isConfirmEnabled } = useAddressSearch(searchByNmi.endpoint, 'NMI');

  useEffect(() => {
    autoOpen?.(true);
  }, []);

  return (
    <Dialog
      id="dedicated-nmi-search"
      open={isOpen}
      onClose={onClose}
      noFullScreenOnMobile={true}
      title={''}
    >
      <Stack space={'xlarge'} dividers={true}>
        <Stack space={'large'}>
          <Stack space={'medium'} data-id={'dedicated-nmi-search-header'}>
            <img
              src="https://www.originenergy.com.au/cdn/images/originenergy/image/upload/illustrations/illustration_find-nmi.svg"
              alt="Everyday Rewards"
              height="128px"
            />
            <Heading variant="h3">Hmm, we can't find the electricity meter at that address</Heading>
            <Text tone="neutralDark">
              Don't worry, we can still check if we have great plans for you using your National
              Meter Identifier (NMI). You can find the property's NMI on your energy bill.
            </Text>
          </Stack>
          <AddressNMISearch
            endpoint={searchByNmi.endpoint}
            onConfirm={(address) => searchByNmi.onConfirm(address)}
            isDedicatedNmiSearch={true}
          />
        </Stack>
        {!isConfirmEnabled && (
          <Stack space="xsmall" data-id={'dedicated-nmi-search-footer'}>
            <Text tone="neutralDark" weight="medium">
              Don't know your NMI?
            </Text>
            <Text tone="neutralDark">
              If you don't have a bill for the property, call us on{' '}
              <TextLink href="tel:132461">13 24 61</TextLink>. We'll ask you for the meter number,
              which you can find on your meter.
            </Text>
          </Stack>
        )}
      </Stack>
    </Dialog>
  );
};
